import { render, staticRenderFns } from "./buttons.pug?vue&type=template&id=035e0ae4&lang=pug&external"
import script from "./buttons.js?vue&type=script&lang=js&external"
export * from "./buttons.js?vue&type=script&lang=js&external"
import style0 from "./buttons.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035e0ae4')) {
      api.createRecord('035e0ae4', component.options)
    } else {
      api.reload('035e0ae4', component.options)
    }
    module.hot.accept("./buttons.pug?vue&type=template&id=035e0ae4&lang=pug&external", function () {
      api.rerender('035e0ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/index.vue"
export default component.exports